let utils = {
  paginator: {
    prev: 'Página Anterior',
    next: 'Página Seguinte',
  },
  see_more: 'Ver Mais',
  jexcel: {
    noRecordsFound:'Nenhum registro encontrado',
    showingPage:'Mostrando página {0} de {1} entradas',
    show:'Mostrar',
    entries:'entradas',
    insertANewColumnBefore:'Inserir uma nova coluna antes',
    insertANewColumnAfter:'Inserir uma nova coluna depois',
    deleteSelectedColumns:'Excluir colunas selecionadas',
    renameThisColumn:'Renomear esta coluna',
    orderAscending:'ordem ascendente',
    orderDescending:'Order decrescente',
    insertANewRowBefore:'Inserir uma nova linha antes',
    insertANewRowAfter:'Inserir uma nova linha depois',
    deleteSelectedRows:'Excluir linhas selecionadas',
    editComments:'Editar comentários',
    addComments:'Adicionar comentários',
    comments:'Comentários',
    clearComments:'Limpar comentários',
    copy:'Copiar ...',
    paste:'Colar ...',
    saveAs: 'Salvar como',
    about: 'Sobre',
    areYouSureToDeleteTheSelectedRows:'Tem certeza de excluir as linhas selecionadas?',
    areYouSureToDeleteTheSelectedColumns:'Tem certeza de excluir as colunas selecionadas?',
    thisActionWillDestroyAnyExistingMergedCellsAreYouSure:'Esta ação irá destruir todas as células mescladas existentes. Você tem certeza?',
    thisActionWillClearYourSearchResultsAreYouSure:'Esta ação limpará seus resultados de pesquisa. Você tem certeza?',
    thereIsAConflictWithAnotherMergedCell:'Há um conflito com outra célula mesclada',
    invalidMergeProperties:'Propriedades mescladas inválidas',
    cellAlreadyMerged:'Célula já mesclada',
    noCellsSelected:'Nenhuma célula selecionada',
  },
  datetimepicker: {
    clear: 'Limpar'
  }
}

export default utils
